<mat-card
  class="rounded-3xl border border-gray-6/60 shadow-sm overflow-hidden bg-white/70 dark:bg-gray-1/70 backdrop-blur-xl"
>
  <!-- Card Header -->
  <div
    class="bg-gray-2/60 py-4 px-6 flex flex-row items-center justify-between border-b border-gray-5/60 w-full"
  >
    <div class="flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-purple-a3 text-purple-9">
        <mat-icon class="w-5! h-5! text-[20px]! flex items-center justify-center leading-none text-purple-9!">
          people
        </mat-icon>
      </div>
      <div>
        <h3 class="text-base font-bold text-gray-12 m-0">Comptes associés</h3>
        <p class="text-xs text-gray-11 m-0">
          Propriétaire légal du bien et compte à l'origine de la création de l'annonce
        </p>
      </div>
    </div>
  </div>

  <!-- Card Content -->
  <div class="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
    <!-- Owner Card -->
    <ng-container
      *ngTemplateOutlet="
        userCardTpl;
        context: {
          $implicit: property().owner,
          badgeLabel: 'Propriétaire du bien',
          badgeIcon: 'home',
          badgeClass: 'bg-indigo-a3 text-indigo-11 border-indigo-a5',
          emptyLabel: 'Aucun profil propriétaire associé à cette annonce',
          defaultInitial: 'P',
        }
      "
    />

    <!-- CreatedBy Card -->
    <ng-container
      *ngTemplateOutlet="
        userCardTpl;
        context: {
          $implicit: property().createdBy,
          badgeLabel: 'Créateur de l\'annonce',
          badgeIcon: 'edit_note',
          badgeClass: 'bg-amber-a3 text-amber-11 border-amber-a5',
          emptyLabel: 'Aucun créateur renseigné',
          defaultInitial: 'C',
        }
      "
    />
  </div>
</mat-card>

<ng-template
  #userCardTpl
  let-user
  let-badgeLabel="badgeLabel"
  let-badgeIcon="badgeIcon"
  let-badgeClass="badgeClass"
  let-emptyLabel="emptyLabel"
  let-defaultInitial="defaultInitial"
>
  <div class="flex flex-col gap-4 rounded-2xl border border-gray-5/60 bg-gray-1/50 dark:bg-gray-2/30 p-5">
    <div class="flex items-center justify-between">
      <span
        class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-bold border"
        [class]="badgeClass"
      >
        <mat-icon class="text-xs! w-3.5! h-3.5!">{{ badgeIcon }}</mat-icon>
        {{ badgeLabel }}
      </span>
    </div>

    @if (asUser(user); as u) {
      <div class="flex items-start gap-4">
        @if (u._id) {
          <a [routerLink]="['/users', u._id]" class="group flex items-start gap-4 min-w-0 transition-colors">
            <aura-avatar
              [srcImage]="u.identity?.avatar?.url"
              [label]="u.identity?.firstName || defaultInitial"
              [size]="'xl'"
              class="group-hover:ring-2 group-hover:ring-primary-9 transition-all rounded-md"
            />
            <div class="flex flex-col min-w-0 gap-1">
              <span
                class="text-base font-bold text-gray-12 group-hover:text-primary-11 group-hover:underline truncate"
              >
                {{ u.identity?.firstName | titlecase }}
                {{ u.identity?.lastName | titlecase }}
              </span>
              @if (u.contactInfos?.email) {
                <div class="flex items-center gap-1.5 text-xs text-gray-11 truncate">
                  <mat-icon class="text-xs! w-3.5! h-3.5! text-gray-9">email</mat-icon>
                  <span class="truncate">{{ u.contactInfos?.email }}</span>
                </div>
              }
              @if (u.contactInfos?.mobileNumber) {
                <div class="flex items-center gap-1.5 text-xs text-gray-11 truncate">
                  <mat-icon class="text-xs! w-3.5! h-3.5! text-gray-9">phone</mat-icon>
                  <span>{{ u.contactInfos?.mobileNumber }}</span>
                </div>
              }
            </div>
          </a>
        } @else {
          <aura-avatar
            [srcImage]="u.identity?.avatar?.url"
            [label]="u.identity?.firstName || defaultInitial"
            [size]="'xl'"
          />
          <div class="flex flex-col min-w-0 gap-1">
            <span class="text-base font-bold text-gray-12 truncate">
              {{ u.identity?.firstName | titlecase }}
              {{ u.identity?.lastName | titlecase }}
            </span>
            @if (u.contactInfos?.email) {
              <div class="flex items-center gap-1.5 text-xs text-gray-11 truncate">
                <mat-icon class="text-xs! w-3.5! h-3.5! text-gray-9">email</mat-icon>
                <a [href]="'mailto:' + u.contactInfos?.email" class="hover:underline truncate">
                  {{ u.contactInfos?.email }}
                </a>
              </div>
            }
            @if (u.contactInfos?.mobileNumber) {
              <div class="flex items-center gap-1.5 text-xs text-gray-11 truncate">
                <mat-icon class="text-xs! w-3.5! h-3.5! text-gray-9">phone</mat-icon>
                <a [href]="'tel:' + u.contactInfos?.mobileNumber" class="hover:underline">
                  {{ u.contactInfos?.mobileNumber }}
                </a>
              </div>
            }
          </div>
        }
      </div>

      <div
        class="pt-3 border-t border-gray-4/60 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-10"
      >
        <div class="flex items-center gap-1">
          <mat-icon class="text-xs! w-3.5! h-3.5!">calendar_today</mat-icon>
          <span>Inscrit le {{ u.createdAt | luxonDate: 'dd/LL/yyyy' }}</span>
        </div>
        @if (u.metadata?.lastLoginAt) {
          <div class="flex items-center gap-1">
            <mat-icon class="text-xs! w-3.5! h-3.5!">login</mat-icon>
            <span>Dernière connexion le {{ u.metadata.lastLoginAt | luxonDate: 'dd/LL/yyyy' }}</span>
          </div>
        }
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center py-6 text-center text-gray-10">
        <mat-icon class="w-8! h-8! text-[32px]! text-gray-8 mb-2">person_off</mat-icon>
        <p class="text-xs italic m-0">{{ emptyLabel }}</p>
      </div>
    }
  </div>
</ng-template>
